import React from "react";

import { Box } from "@mui/material";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";

interface VoiceCommandLabelProps {
  children: React.ReactNode;
}

// Highlights a spoken headset voice command inline within instructional text
const VoiceCommandLabel: React.FC<VoiceCommandLabelProps> = ({ children }) => {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.4,
        backgroundColor: "#e8e9ff",
        color: "#3f59b8",
        border: "1px solid #bfb7f0",
        borderRadius: "999px",
        px: 1,
        py: 0.1,
        mx: 0.25,
        fontSize: "0.85em",
        fontWeight: 600,
        fontStyle: "italic",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
      }}
    >
      <RecordVoiceOverIcon sx={{ fontSize: "1em" }} />
      "{children}"
    </Box>
  );
};

export default VoiceCommandLabel;
